
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/matching-service",
      function () {
        return require("private-next-pages/matching-service/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/matching-service"])
      });
    }
  